module.exports = __webpack_public_path__ + "static/media/logo.919e5acc.png";